import { React } from 'react'
import "./FilterMultiSelect.css"
import { Checkbox, FormControlLabel, FormGroup, Typography } from '@mui/material';

const FilterMultiSelect = ({ title, options, selectedOptions, setSelectedItems, addNode, removeNode, updateNode, path, labels }) => {

    const checkboxStyles = {
        color: '#D2D2D2',
        '&.Mui-checked': { color: '#239DAB' },
        '&:hover': { color: '#239DAB', backgroundColor: 'rgba(35, 157, 171, 0.1)' },
    };



    const handleOptionChange = (field_name, option) => (event) => {
        setSelectedItems((prev) => {
            const currentOptions = prev[field_name] || [];

            // Update selected items based on whether the option is being added or removed
            const updatedOptions = event.target.checked
                ? [...currentOptions, option]
                : currentOptions.filter((item) => item !== option);

            // Clone the path for use in tree management
            const fullPath = [...path, { key: field_name, value: 0 }];

            if (event.target.checked) {
                addNode(fullPath, { is_group: 0, "operation": "or", values: updatedOptions });
            }
            else if (event.target.checked == false && updatedOptions.length !== 0) {
                updateNode(fullPath, { is_group: 0, "operation": "or", values: updatedOptions }, title);
            }
            else if (updatedOptions.length === 0) {
                removeNode(fullPath);
            }

            // If `updatedOptions` is empty, remove `field_name` from `selectedItems`
            if (updatedOptions.length === 0) {
                const { [field_name]: _, ...rest } = prev;
                return rest;
            }
            return {
                ...prev,
                [field_name]: updatedOptions,
            };
        });
    };


    return (
        <FormGroup>
           {options.map((option, index) => {
                 const labelValue = labels[option] || option;  // Fallback to option if label doesn't exist
                 return(
                    <FormControlLabel
                    sx={{
                        marginTop: '-5px',
                    }}
                    label={
                        <Typography
                            sx={{
                                color: "#19191D",
                                fontFamily: "Sfpro400",
                                fontSize: "13px",
                                textTransform: "capitalize"
                            }}>{labelValue}
                        </Typography>}
                    control={
                        <Checkbox
                            checked={selectedOptions.includes(option)}
                            onClick={(event) => event.stopPropagation()}
                            onChange={(e) => handleOptionChange(title, option)(e)}
                            sx={checkboxStyles} />}
                />
                 );
                    })
                }
        </FormGroup>
    );
}

export default FilterMultiSelect
